<template>
	<TIcon>
		<path
			d="M11.25 20.25a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1-.75-.75V3.75A.75.75 0 0 1 4.5 3h6a.75.75 0 1 1 0 1.5H5.25v15h5.25a.75.75 0 0 1 .75.75Zm10.28-8.78-3.75-3.75a.75.75 0 1 0-1.06 1.06l2.47 2.47H10.5a.75.75 0 1 0 0 1.5h8.69l-2.47 2.47a.75.75 0 1 0 1.06 1.06l3.75-3.75a.747.747 0 0 0 0-1.06Z"
		/>
	</TIcon>
</template>

<script setup lang="ts">
import TIcon from '@/app/common/TIcon.vue'
</script>
